import React, {Component} from 'react';
import {Row, Col, Tabs, Tab} from "react-bootstrap";
import {Link} from "react-router-dom";
import HomeService from "../HomeService";
import DashboardPowiadomienieContainer from "./components/DashboardPowiadomienieContainer";
import {TopAlertUwaga} from "../../../componentsTopsa/alerty/TopAlerts";


export default class DashboardTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setLoader: false,
            czyBladPobierania: false,
            kierowcy: [],
            pojazdy: [],
            promocje: [],
            okresy: []
        };

    }


    componentDidMount() {
        this.pobierzInformacjeNaDashboard();
    }

    pobierzInformacjeNaDashboard() {
        this.setState({
            setLoader: true,
            czyBladPobierania: false,
        })

        HomeService.pobierzDaneNaDashboard().then(function (response) {
            if(response.status<300){
                this.setState({
                    kierowcy: response.data.kierowcyprzekroczdaty,
                    pojazdy: response.data.pojazdyprzekroczdaty,
                    promocje: response.data.promocje,
                    okresy: response.data.okresy,
                    setLoader: false,
                    czyBladPobierania: false,
                })
            }
            else{
                this.setState({
                    setLoader: false,
                    czyBladPobierania: true,
                })
            }

        }.bind(this)).catch(function (err) {
            this.setState({
                setLoader: false,
                czyBladPobierania: true,
            })
            console.log(err)
        }.bind(this))
    }


    render() {
        return (
            <div>
                {this.state.setLoader ?

                    <div>
                        <div id={'smallLoader'}>
                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                            <div>Trwa ładowanie danych...</div>
                        </div>
                    </div>
                    :
                    this.state.czyBladPobierania ?
                        <TopAlertUwaga text={'Nie można załadować danych - błąd pobierania'}/>
                        :
                        <div>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <div className={'powiadomienie-container'}>
                                        <div className={'heading_name'}>
                                            Obecny okres
                                            <small>na który wygenerowany jest rozkład jazdy</small>
                                        </div>
                                        <div className={'thumbnail'}>
                                            <div className={'powiadomienie-alert'}>
                                                Obecny okres trwa od <label style={{marginBottom:0}}>{this.state.okresy.length>0? this.state.okresy[0].wartosc:''}</label> do <label style={{marginBottom:0}}>{this.state.okresy.length>0? this.state.okresy[1].wartosc:''}</label>. Do końca pozostało <label style={{marginBottom:0}}>{this.state.okresy.length>0? this.state.okresy[1].ilosc_dni_roznica:''}</label> dni
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <DashboardPowiadomienieContainer tytul={'Trwające promocje'} podtytul={'Promocje obejmujące obecny dzień'}
                                                                     dane={this.state.promocje} typ={'imie_naz'} typId={'id_ki'}
                                                                     url={'konfiguracja/zarzadzanie-biletami/promocje'} czyPromocje={true}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={6}>
                                    <DashboardPowiadomienieContainer tytul={'Moduł Kierowcy'} podtytul={'Kończące się terminy'}
                                                                     dane={this.state.kierowcy} typ={'imie_naz'} typId={'id_ki'}
                                                                     url={'konfiguracja/zarzadzanie-zasobami/kierowcy'}/>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <DashboardPowiadomienieContainer tytul={'Moduł Pojazdy'} podtytul={'Kończące się terminy'}
                                                                     dane={this.state.pojazdy} typ={'nr_rej'} typId={'id_po'}
                                                                     url={'konfiguracja/zarzadzanie-zasobami/pojazdy'}/>

                                </Col>
                            </Row>
                        </div>
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/home/dashboard/DashboardTabContainer.js